export const fetchSupportPoolsTypes = [
  'FETCH_SUPPORT_POOLS',
  'FETCH_SUPPORT_POOLS_SUCCESS',
  'FETCH_SUPPORT_POOLS_FAIL',
];

export const fetchMessagesTypes = [
  'FETCH_MESSAGES',
  'FETCH_MESSAGES_SUCCESS',
  'FETCH_MESSAGES_FAIL',
];

export const acceptSupportTypes = [
  'ACCEPT_SUPPORT',
  'ACCEPT_SUPPORT_SUCCESS',
  'ACCEPT_SUPPORT_FAIL',
];

export const sendMessageTypes = [
  'SEND_MESSAGE',
  'SEND_MESSAGE_SUCCESS',
  'SEND_MESSAGE_FAIL',
];

export const resolveSupportTypes = [
  'RESOLVE_SUPPORT',
  'RESOLVE_SUPPORT_SUCCESS',
  'RESOLVE_SUPPORT_FAIL',
];

export const unresolveSupportTypes = [
  'UNRESOLVE_SUPPORT',
  'UNRESOLVE_SUPPORT_SUCCESS',
  'UNRESOLVE_SUPPORT_FAIL',
];


export const SELECT_SUPPORT_POOL_USER = 'SELECT_SUPPORT_POOL_USER';
export const SET_LAST_MESSAGES = 'SET_LAST_MESSAGES';

export const SUBSCRIBE_TO_MESSAGES = 'SUBSCRIBE_TO_MESSAGES';



// WEBPACK FOOTER //
// ./src/modules/messages/action_types.js